import { actions } from '../nlpAnalyzer'
import { FeedbotMiddleware, isThunk } from '../types'
import { getBotDefaultLocaleSelector } from './selectors/selectors'
import { nlpModelsSelector } from '../botNlp'

export const outOfDateAnalysisMarkingMiddleware: FeedbotMiddleware =
  ({ dispatch, getState }) =>
  next =>
  action => {
    if (isThunk(action)) {
      return next(action)
    }

    const previousModels = nlpModelsSelector(getState())
    const previousBotLocale = getBotDefaultLocaleSelector(getState())

    const result = next(action)

    const nextModels = nlpModelsSelector(getState())
    const nextBotLocale = getBotDefaultLocaleSelector(getState())

    if (previousBotLocale !== nextBotLocale) {
      dispatch(actions.setAnalysisOutOfDate())
      return result
    }

    if (previousModels !== nextModels) {
      dispatch(actions.setAnalysisOutOfDate())
      return result
    }

    return result
  }
